/**
 * Category archive: banner fade-in.
 */
const SELECTORS = {
    banner: '[data-category-banner]',
};
export function initCategoryPage() {
    document.querySelectorAll(SELECTORS.banner).forEach((banner) => {
        requestAnimationFrame(() => {
            banner.classList.add('is-visible');
        });
    });
}
